// Neutral adapter: connect a consent-aware provider to this event, never form data.
const placements = ['hero', 'nav', 'footer', 'partnership', 'download'];
const schema = {
  download_app_click: {
    platform: ['ios', 'android'],
    placement: placements
  },
  partner_cta_click: {
    placement: placements
  },
  partner_form_start: {},
  partner_form_captcha_error: {},
  partner_form_submit: {},
  partner_form_success: {},
  partner_form_error: {
    category: ['network', 'server', 'validation']
  }
};
export function track(event, values = {}) {
  if (!Object.prototype.hasOwnProperty.call(schema, event)) return;
  const detail = {
    event
  };
  for (const [key, allowed] of Object.entries(schema[event])) {
    if (!allowed.includes(values[key])) return;
    detail[key] = values[key];
  }
  window.dispatchEvent(new CustomEvent('coffeein:analytics', {
    detail
  }));
}
